module.exports = __webpack_public_path__ + "img/img5-1.2435ba5b.jpg";